export default __webpack_public_path__ + "static/ivybrownlogo-3afe3ab4885f8dc281d7b0243026f827.png";